import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Button, Modal, Table } from 'semantic-ui-react'

class ModalShowItem extends React.PureComponent {
  state = {
    open: false,
  }

  render() {
    const { open } = this.state
    const { items, merchantKey, selectedItems, discountRate, hasCustomItem } = this.props
    const merchantItems = items[merchantKey]

    const customItemDiscount = _.reduce(
      hasCustomItem,
      (result, custom) => {
        const itemDiscountRate = custom.discount_rate

        custom.item_ids.forEach(itemKey => {
          // eslint-disable-next-line no-param-reassign
          result[itemKey] = itemDiscountRate
        })

        return result
      },
      {}
    )

    return (
      <Modal
        onOpen={() => this.setState({ open: true })}
        open={open}
        trigger={<Button size="mini">{`Show Items (${_.size(selectedItems)})`}</Button>}
      >
        <Modal.Header>All Items</Modal.Header>
        <Modal.Content>
          <div>
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>Discount Rate</Table.HeaderCell>
                  <Table.HeaderCell>Current Price</Table.HeaderCell>
                  <Table.HeaderCell>Discount Price</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {merchantItems && _.size(merchantItems) > 0
                  ? _.map(selectedItems, (itemKey, key) => {
                      const itemDetail = merchantItems[itemKey]
                      const discountPercent = customItemDiscount[itemKey] || discountRate

                      const itemName = _.get(itemDetail, 'name', 'N/A')
                      const currentPrice = _.get(itemDetail, 'current_price', 0)
                      const discountPrice = currentPrice - (currentPrice * discountPercent) / 100

                      return (
                        <Table.Row key={key}>
                          <Table.Cell>{itemName}</Table.Cell>
                          <Table.Cell>{`${discountPercent}%`}</Table.Cell>
                          <Table.Cell
                            style={{ textDecorationLine: 'line-through', margin: '5px', color: 'grey' }}
                          >{`$ ${Number(currentPrice).toFixed(2)}`}</Table.Cell>
                          <Table.Cell>{`$ ${Number(discountPrice).toFixed(2)}`}</Table.Cell>
                        </Table.Row>
                      )
                    })
                  : null}
              </Table.Body>
            </Table>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={() => this.setState({ open: false })}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapState = ({ items }) => ({
  items: items.data,
})

export default connect(mapState)(ModalShowItem)



// WEBPACK FOOTER //
// ./src/components/promotions/views/ModalShowItems.js